import { render, staticRenderFns } from "./landingpage.vue?vue&type=template&id=6c0ce14c&"
import script from "./landingpage.vue?vue&type=script&lang=ts&"
export * from "./landingpage.vue?vue&type=script&lang=ts&"
import style0 from "./landingpage.vue?vue&type=style&index=0&id=6c0ce14c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TrackingNoscript: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/_trackingNoscript.vue').default,HomepageHeader: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/homepage/HomepageHeader.vue').default,PageFooter: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/page/PageFooter.vue').default})
